module.exports = __webpack_public_path__ + "img/2024112903.b2d9f5ae.png";